import React from 'react'
import warning from "../assets/images/Brake Warning.svg"


const ElizabethSection = () => {
  return (
      <div className="mt-16 md:pb-0 pb-8 dr-ali-banner">
          <div className="max-w-[900px] mx-auto flex flex-wrap md:flex-nowrap items-start gap-6 flex-col">
            <div className="flex md:flex-row flex-col md:gap-14 gap-5 items-center justify-center md:pr-2 pr-0">
              <div className="flex-shrink-0 hidden md:block">
                <img
                  src="https://cdn.blackincae.com/kMo-dr-ali-1-1-.png"
                  alt="Dr. ali"
                  className="w-[300px] h-[300px] object-cover"
                />
              </div>
              <div className="flex items-center gap-4 py-4 block md:hidden px-4 pt-10 text-start">
                <img
                  className="w-28 h-28 rounded-full"
                  src="https://cdn.blackincae.com/kMo-dr-ali-1-1-.png"
                  alt="Dr. ali"
                />
                <div className="text-[24px] font-bold text-white bold-font">
                  <div>Hey there, it’s Dr. Ali here again…</div>
                </div>
              </div>
              <div className="flex flex-col gap-6 text-white text-start md:px-0 px-4">
                <p className="text-[28px] font-bold hidden md:block bold-font">
                  Hey there, it’s Dr. Ali here again…
                </p>
                <p className="text-[20px] font-normal leading-[28px]">
                  And I want to congratulate you again on making the smart
                  decision to invest in yourself and get in on Lung Renew® today. 
                </p>
                <p className="text-[20px] font-normal leading-[28px]">
                  Lung Renew® is the
                  <span className="font-bold">
                    {" "}
                    ONE AND ONLY SOLUTION{" "}
                  </span>{" "}
                  designed to protect delicate respiratory tissue from deadly
                  catalytic carbon.
                </p>
                <p className="text-[20px] font-normal leading-[28px]">
                  Right now, the guys in the warehouse are getting your order
                  processed.
                </p>
              </div>
            </div>

            <div className="md:px-0 px-4">
              <div className="bg-[#B91111] mt-4 border border-white rounded-[4px] md:px-8 px-2">
                <div className="flex flex-wrap md:flex-nowrap items-center md:gap-3 gap-0 justify-center md:py-0 py-2">
                  <img
                    src={warning}
                    alt="Brand Logo"
                    className="w-[40px] h-[40px]"
                  />

                  <p className="text-white md:text-[20px] text-[18px] font-semibold italic leading-[24px]">
                    So don’t close this page or hit the back button, that can
                    cause problems with your order.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full">
              <p className="text-white text-[20px] font-normal text-center md:px-0 px-4">
                Now, you’re already on your way to better lung health - and I’m
                so excited for you.
              </p>
            </div>

            <div className="w-full">
              <span className="gift-highlight-yellow bold-font">
                And get this:
              </span>
            </div>

            <div className="w-full">
              <p className="text-white text-[20px] font-normal text-center">
                because of that one decision, life is about to get even better
                for you. 
              </p>
            </div>

            <div className="w-full">
              <p className="text-white text-[20px] font-normal text-center mx-auto max-w-xl px-2">
                That’s because I didn’t want to stop at just helping you solve
                the problem of trapped mucus in your airways. 
              </p>
            </div>
          </div>
        </div>
  )
}

export default ElizabethSection